

























import { SharedState } from "@/common/state";
import Vue from "vue";
export default Vue.extend({
  props: ["unsupported_user"],
  setup() {
    return {
      logout_from_ms: SharedState.logout_from_ms,
    };
  },
});
